"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_card_cell_model_1 = require("./form-card-cell.model");
var FormCardRowModel = /** @class */ (function () {
    function FormCardRowModel() {
        this.cells = [];
    }
    FormCardRowModel.prototype.insertControllerOnIndex = function (controller, indexToPush) {
        this.cells.splice(indexToPush, 0, form_card_cell_model_1.FormCardCellModel.cellWithController(controller));
    };
    FormCardRowModel.prototype.appendController = function (controller) {
        this.cells.push(form_card_cell_model_1.FormCardCellModel.cellWithController(controller));
    };
    FormCardRowModel.prototype.appendNestedCard = function (nestedCard) {
        this.cells.push(form_card_cell_model_1.FormCardCellModel.cellWithCard(nestedCard));
    };
    FormCardRowModel.prototype.insertNestedCardOnIndex = function (nestedCard, indexToPush) {
        this.cells.splice(indexToPush, 0, form_card_cell_model_1.FormCardCellModel.cellWithCard(nestedCard));
    };
    FormCardRowModel.prototype.insertCellInIndex = function (cell, indexToPush) {
        this.cells.splice(indexToPush, 0, cell);
    };
    FormCardRowModel.prototype.appendCell = function (cell) {
        this.cells.push(cell);
    };
    return FormCardRowModel;
}());
exports.FormCardRowModel = FormCardRowModel;
//# sourceMappingURL=form-card-row.model.js.map